"use strict";

exports.__esModule = true;
exports.createValueFormatter = createValueFormatter;
var _date = require("./date");
var _device = require("./device");
var _user = require("./user");
var _ticketing = require("./ticketing");
var _PlantStateActivities = require("../../../PlantStateActivities");
var _timestampFormatter = require("./timestampFormatter");
// FixMe: Make sure to refactor when groups are present in download
/**
 * Returns a function for formatting cell values
 */
function createValueFormatter(_ref) {
  var translate = _ref.translate,
    time = _ref.time,
    devices = _ref.devices,
    users = _ref.users,
    ticketTypes = _ref.ticketTypes,
    plantStateActivities = _ref.plantStateActivities;
  return function (column, rawValue) {
    if (rawValue === undefined) {
      return "";
    }

    // go through each custom formatter on a column
    switch (column.type) {
      case "day":
        return (0, _timestampFormatter.getDay)(rawValue);
      case "week":
        return (0, _timestampFormatter.getWeek)(rawValue);
      case "month":
        return (0, _timestampFormatter.getMonth)(rawValue);
      case "quarter":
        return (0, _timestampFormatter.getQuarterRange)(rawValue);
      case "year":
        return (0, _timestampFormatter.getYear)(rawValue);
      case "fractionalPercent":
        return (rawValue * 100).toFixed(2) + " %";
      case "status":
        return (0, _ticketing.formatStatus)(rawValue, column, translate);
      case "date":
        //Handle time in milliseconds
        if (typeof rawValue === "number") return (0, _date.formatDate)(new Date(rawValue).toISOString(), column, time);
        // Handle time in zulu
        return (0, _date.formatDate)(rawValue, column, time);
      case "deviceName":
        return (0, _device.formatDeviceName)(rawValue, column, devices);
      case "state":
        return (0, _PlantStateActivities.formatPlantState)(plantStateActivities, rawValue);
      case "activity":
        return (0, _PlantStateActivities.formatPlantActivity)(plantStateActivities, rawValue);
      case "creator":
        return (0, _user.formatCreator)(rawValue, column, users, translate);
      case "author":
        return (0, _user.formatAuthor)(rawValue, column, users, translate);
      case "assignee":
        return (0, _user.formatAssignee)(rawValue, column, users, translate);
      case "ticketTypes":
        return (0, _ticketing.formatTicketTypeList)(rawValue, column, ticketTypes);
      case "ticketPriority":
        return (0, _ticketing.formatTicketPriority)(rawValue, column, translate);
      case "devicesAndGroups":
        return (0, _device.formatDevicesAndGroupsList)(rawValue, column, devices);
      case "ms":
        // TODO with comments
        return rawValue;
      default:
        // do nothing i.e. use the raw value as is
        return rawValue;
    }
  };
}